var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalculate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4305_7058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6676 2H3.33431C2.60098 2 2.00098 2.6 2.00098 3.33333V12.6667C2.00098 13.4 2.60098 14 3.33431 14H12.6676C13.401 14 14.001 13.4 14.001 12.6667V3.33333C14.001 2.6 13.401 2 12.6676 2ZM12.6676 12.6667H3.33431V3.33333H12.6676V12.6667Z",
    fill: "#409958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50081 5.14667H4.16748V6.14667H7.50081V5.14667Z",
    fill: "#409958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0008 10.5H8.66748V11.5H12.0008V10.5Z",
    fill: "#409958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0008 8.83331H8.66748V9.83331H12.0008V8.83331Z",
    fill: "#409958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3348 12H6.3348V10.6666H7.66813V9.66665H6.3348V8.33331H5.3348V9.66665H4.00146V10.6666H5.3348V12Z",
    fill: "#409958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.39466 7.3L10.3347 6.36L11.2747 7.3L11.9813 6.59333L11.0413 5.64667L11.9813 4.70667L11.2747 4L10.3347 4.94L9.39466 4L8.68799 4.70667L9.62799 5.64667L8.68799 6.59333L9.39466 7.3Z",
    fill: "#409958"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4305_7058"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculate);
export default __webpack_public_path__ + "static/media/calculate.15142e8c9b138b4c6f403ba465a8a555.svg";
export { ForwardRef as ReactComponent };